import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  MockBoardingPassResult,
  MockJourney,
} from '@dapi/sdk/spec';
import {
  noItemToPayError,
} from '../../mock/data';
import {
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';
import {
  acceptedChosenJourney,
  journeyElementIds,
  journeys,
  validRegulatoryJourney,
  validRegulatoryJourneyFirstPax,
} from './ow-1journey-2Adt-MissingRegulatory-AddBag-Pay-Contacts/journey-logic';
import {
  addRegulatoryDetailsFirstPax,
  addRegulatoryDetailsSecondPax,
  getRegulatoryDetailsFirstPax,
  getRegulatoryDetailsFirstPaxCompleted,
  getRegulatoryDetailsSecondPax,
  getRegulatoryDetailsSecondPaxCompleted,
} from './ow-1journey-2Adt-MissingRegulatory-AddBag-Pay-Contacts/regulatory-logic';

const bp: MockBoardingPassResult[] = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;

const retrieveJourney: MockJourney[] = [
  validRegulatoryJourneyFirstPax,
  validRegulatoryJourney,
  acceptedChosenJourney
];

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

/**
 * Connection Flights
 * 1 Journey - 2 flights -2 ADTs
 * Validate itinerary details
 */
export const ow1Journey2AdtConnectionFlightsRetrieve: MockMap = {
  addRegulatoryDetails: [
    ...[...addRegulatoryDetailsFirstPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    })),
    ...[...addRegulatoryDetailsSecondPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }))
  ],
  generateBoardingPasses: [createMockDataWithResponse(bp, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [
    createMockData({
      ...getRegulatoryDetailsFirstPax,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPax,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsFirstPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    })
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourney: retrieveJourney.map((j) => createMockData(j)),
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
